import {Label} from "./Label";
import {Client} from "./Client";
import {AutomationListTrigger} from "./AutomationListTrigger";
import {User} from "./User";
import {AutomationListFilter} from "./AutomationListFilter";

export class AutomationList {
    constructor({
                    //attributes
                    id= null,
                    category_id= null,
                    company_id= null,
                    recurrence_id= null,
                    type= 'static',
                    selection_type= 'all',
                    name= '',
                    active= 1,
                    size= 0,
                    fired_triggers_count= 0,
                    triggers_active= 1,
                    opportunities_active= 1,
                    fb_ads_active= 1,
                    fb_event= null,
                    google_ads_active= 1,
                    google_event= null,
                    pipe_id= null,
                    opportunity_connector= null,
                    opportunity_message_id= null,
                    opportunity_expire_in= null,
                    opportunity_expire_unit= 0,
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    filters= [],
                    integrations= [],
                    out_filters= [],
                    category=null,
                    clients= [],
                    triggers= [],
                    users= [],
                    last_sync=null,
                } = {}) {

        //fill attributes
        this.id=id;
        this.category_id=category_id;
        this.company_id=company_id;
        this.type=type;
        this.last_sync=last_sync;
        if(type==="dynamic"||type==="birthday")
            this.selection_type = "filter"
        else
            this.selection_type=selection_type;
        this.name=name;
        this.active=active;
        this.size=size;
        this.triggers = (triggers||[]).map(t=>new AutomationListTrigger(t))
        if(!this.hasDefaultTrigger())
            this.triggers.unshift(AutomationListTrigger.createDefaultTrigger(this.name))
        this.fired_triggers_count=fired_triggers_count;
        this.triggers_active=Boolean(triggers_active);
        this.opportunities_active=Boolean(opportunities_active);
        this.fb_ads_active=Boolean(fb_ads_active);
        this.fb_event=fb_event;
        this.google_event=google_event;
        this.google_ads_active=Boolean(google_ads_active);
        this.pipe_id=pipe_id;
        this.recurrence_id=recurrence_id;
        this.opportunity_connector=opportunity_connector;
        this.opportunity_message_id=opportunity_message_id;
        this.opportunity_expire_in=opportunity_expire_in;
        this.opportunity_expire_unit=opportunity_expire_unit;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.category = new Label(category||{});
        this.clients = (clients||[]).map(c=>new Client(c));
        this.users = (users||[]).map(u=>new User(u));
        this.user_ids = (users||[]).map(u=>u.id)
        this.integrations = (integrations||[])


        let mapFilters = f=>{
            return new AutomationListFilter(f);
        }
        this.filters = (filters||[]).map(mapFilters)
        this.out_filters = (out_filters||[]).map(mapFilters)
    }

    get _name(){
        return this.name
    }

    set _name(v){
        this.name=v;
        if(this.hasDefaultTrigger())
            this.getDefaultTrigger().name = v
    }

    hasDefaultTrigger(){
        return this.triggers.some(t=>t.is_default_list)
    }

    getDefaultTrigger(){
        return this.triggers.find(t=>t.is_default_list)
    }

    newTrigger(){
        this.triggers.push(
            new AutomationListTrigger({
                name: "Sublista " + this.triggers.length
            })
        )
    }

    removeTrigger(index){
        this.triggers.splice(index, 1)
    }

    hasIntegration(name){
        return this.integrations.some(i=>i.type_string===name)
    }
}

export function createAutomationList(data={}) {
    return Object.freeze(new AutomationList(data));
}